<template>
    <div v-if="hasAccess" class="h-full">
        <top-nav-bar goto="/?page=requests">
            <router-link to="/requests" tag="button"
                         class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase">
                <i class="fas fa-plus mr-2"></i>
                Create Request
            </router-link>
        </top-nav-bar>

        <div v-if="pendingRequests.length > 0" class="mt-8 border border-red bg-red-lightest p-4 flex items-center">
            <h4 class="mb-2 md:mb-0 md:w-64 mr-4 text-base">{{ pendingRequests.length }} pending Requests</h4>
            <p class="text-sm text-grey-darker font-normal mb-0">Pending requests are requests you've added while
                offline. These requests will be posted as soon as you are online again, and will not appear in the list
                below until then. Please note that some of these requests might not go through, due to the request
                rules.</p>
        </div>

        <div v-if="!loading" class="py-4">
            <div v-if="hasMonths()">
                <div v-for="(requests, month) in months" :key="month" class="mb2">
                    <h3 class="text-center">{{ getMonthName(month) }}</h3>
                    <list>
                        <list-item url="#" v-for="request in requests" :key="request.id" @click.native.prevent
                                   @click="navigateTo(request)">
                            <template slot="icon">
                                <icon :icon="request.icon" :classes="request.color + ' w-6 h-6'"></icon>
                            </template>
                            <template slot="title">{{ request.title }}</template>
                            <template slot="sub-title">{{ request.sub_title }}</template>
                        </list-item>
                    </list>
                </div>
            </div>
            <div class="text-center p-4 text-grey-dark" v-if="!hasMonths()">
                You currently have no stored requests.
            </div>
        </div>
        <div v-else class="h-full flex items-center justify-center">
            <div class="spinner-blue"></div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import {size} from 'lodash'
import CanAccessView from "../mixins/CanAccessView";

export default {
    mixins: [CanAccessView],
    data() {
        return {
            loading: true,
            months: {}
        }
    },

    computed: {
        pendingRequests() {
            return this.$pendingApi('requests', 'hr').get([])
        }
    },

    mounted() {
        this.$api('hr').get('requests')
            .then(({data}) => {
                this.months = data.data
                this.loading = false
            })
    },

    methods: {
        navigateTo(request) {
            this.$router.push('/requests/' + request.id)
        },

        hasMonths() {
            return size(this.months)
        },

        getMonthName(month) {
            return moment(month, 'YYYY-MM').format('MMMM YYYY')
        },
    },


}
</script>
